// extracted by mini-css-extract-plugin
export default {"mainPageWrapper":"confirmPage_mainPageWrapper__RxP+f","logoWrapper":"confirmPage_logoWrapper__cFtat","redirectionAction":"confirmPage_redirectionAction__jKfC2"};